import appClient from '../../common/services/AppClient';
import { endpoints } from '../../../config';

export default class DocumentViewService {
    // Original document (unmodified)
    async getDocument(path: string): Promise<Blob | undefined> {
        const url = `${endpoints.manageUrl}document/${path}`;
        const resp = await appClient.get<Blob | undefined>(url, 'blob');
        return resp.unwrapOr(undefined);
    }

    // Preview document (Excel formulas removed when applicable)
    async getPreviewDocument(path: string): Promise<Blob | undefined> {
        const url = `${endpoints.manageUrl}document/preview/${path}`;
        const resp = await appClient.get<Blob | undefined>(url, 'blob');
        return resp.unwrapOr(undefined);
    }
}
